import { JVPGetAnnualSettingsResponse } from 'Utils/apiTypes';

export type FederalLimitsList = JVPGetAnnualSettingsResponse[];

/**
 * Resolves the federal (IRS) benefit-limits entry for one plan year out of the per-year
 * list on config.federal_limits (also accepts a single entry directly).
 *
 * A requested plan year with no matching entry returns undefined. It must never fall back
 * to a different year's entry — that would show one plan year's limits mislabeled as
 * another's, e.g. after a partial JVP outage where only one year loaded. With no plan year
 * requested, falls back to the current calendar year, then to the latest entry in the list.
 */
export const getAnnualSettingsForYear = (
  federalLimits: FederalLimitsList | JVPGetAnnualSettingsResponse | null | undefined,
  planYear?: number,
): JVPGetAnnualSettingsResponse | undefined => {
  if (!federalLimits) {
    return undefined;
  }

  const entries = Array.isArray(federalLimits) ? federalLimits : [federalLimits];
  if (entries.length === 0) {
    return undefined;
  }

  const findByYear = (year: number | string) => entries.find((entry) => String(entry?.year) === String(year));

  if (planYear !== undefined) {
    return findByYear(planYear);
  }

  return findByYear(new Date().getFullYear()) ?? entries[entries.length - 1];
};
